<template>
    <header>
        <img v-if="logoUrl" :src="logoUrl" class="leading logo" alt="brand logo" />
        <div class="trailing"><slot name="trailing" :title="title"></slot></div>
        <div class="title">
            <h3>
                {{ title }} <i v-if="version"> ( version {{ version.version }} ) </i>
            </h3>
            <h6>{{ subTitle }}</h6>
        </div>
    </header>
</template>

<script>
export default {
    props: { plano: { type: Object }, logoUrl: { type: String } },
    data: () => ({ selected: false }),
    computed: {
        title() {
            return (this.plano && this.plano.name) || "";
        },
        subTitle() {
            if (!this.plano) {
                return "";
            }
            return `${this.plano.zone.name} - ${this.plano.stand_design.name} – ${this.plano.campaign.name}`;
        },
        version() {
            return this.plano && this.plano.version;
        }
    }
};
</script>

<style lang="scss">
.trailing div.langselector {
    padding: 0;
    > * {
        color: whitesmoke;
    }
}
</style>
<style lang="scss">
header > .trailing > * + * {
    margin-left: 20px;
}
</style>

<style lang="scss" scoped>
@import "../assets/css/themes";

header {
    // TODO: dark light
    background-color: black;
    color: white;

    height: 68px;
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;

    .leading {
        left: 0;
    }
    .trailing {
        right: 0;
    }

    .leading,
    .trailing {
        margin: 0 10px;
        position: absolute;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .title {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    h3 {
        font-size: 1.17em;
    }
    h6 {
        font-size: 0.67em;
    }

    h3,
    h6 {
        margin: 0;
        text-transform: uppercase;
    }
    .logo {
        max-width: 350px;
        max-height: 50px;
    }
}
</style>



// WEBPACK FOOTER //
// plano-header.vue?1f5483dd